export default __webpack_public_path__ + "static/media/020_start.first.c2be1b4b.webp";